import { i as o, t as c, e as u } from "./directive-C5OgdAy2.js";
import { E as r, T as a } from "./abstract-base-CdeHT0x1.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class i extends o {
  constructor(t) {
    if (super(t), this.it = r, t.type !== c.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === r || t == null) return this._t = void 0, this.it = t;
    if (t === a) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const e = [t];
    return e.raw = e, this._t = { _$litType$: this.constructor.resultType, strings: e, values: [] };
  }
}
i.directiveName = "unsafeHTML", i.resultType = 1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class s extends i {
}
s.directiveName = "unsafeSVG", s.resultType = 2;
const d = u(s);
export {
  d as o
};
